import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_EXPORT_SUBS_AUDIT_TRAIL_BEGIN,
  MANAGE_SUBS_EXPORT_SUBS_AUDIT_TRAIL_SUCCESS,
  MANAGE_SUBS_EXPORT_SUBS_AUDIT_TRAIL_FAILURE,
  MANAGE_SUBS_EXPORT_SUBS_AUDIT_TRAIL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { EXPORT_BOS_API_REQUEST_URL } from '../../../common/apiConfig';
export function exportSubsAuditTrail(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_EXPORT_SUBS_AUDIT_TRAIL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios({
        url: `${EXPORT_BOS_API_REQUEST_URL}/subsEvents/subsEventExport`,
        method: 'post',
        data: args,
        responseType: 'blob',
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_EXPORT_SUBS_AUDIT_TRAIL_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_EXPORT_SUBS_AUDIT_TRAIL_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportSubsAuditTrailError() {
  return {
    type: MANAGE_SUBS_EXPORT_SUBS_AUDIT_TRAIL_DISMISS_ERROR,
  };
}

export function useExportSubsAuditTrail() {
  const dispatch = useDispatch();

  const { exportSubsAuditTrailPending, exportSubsAuditTrailError } = useSelector(
    state => ({
      exportSubsAuditTrailPending: state.manageSubs.exportSubsAuditTrailPending,
      exportSubsAuditTrailError: state.manageSubs.exportSubsAuditTrailError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportSubsAuditTrail(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportSubsAuditTrailError());
  }, [dispatch]);

  return {
    exportSubsAuditTrail: boundAction,
    exportSubsAuditTrailPending,
    exportSubsAuditTrailError,
    dismissExportSubsAuditTrailError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_EXPORT_SUBS_AUDIT_TRAIL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportSubsAuditTrailPending: true,
        exportSubsAuditTrailError: null,
      };

    case MANAGE_SUBS_EXPORT_SUBS_AUDIT_TRAIL_SUCCESS:
      // The request is success
      fileDownload(action.data, `Sub Repositories Audit Trail Reports.xlsx`);
      return {
        ...state,
        exportSubsAuditTrailPending: false,
        exportSubsAuditTrailError: null,
      };

    case MANAGE_SUBS_EXPORT_SUBS_AUDIT_TRAIL_FAILURE:
      // The request is failed
      return {
        ...state,
        exportSubsAuditTrailPending: false,
        exportSubsAuditTrailError: action.data.error,
      };

    case MANAGE_SUBS_EXPORT_SUBS_AUDIT_TRAIL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportSubsAuditTrailError: null,
      };

    default:
      return state;
  }
}
